<template>
  <div :class="['grid gap-6', gridClasses[columns]]">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  columns?: 1 | 2 | 3 | 4
}

withDefaults(defineProps<Props>(), {
  columns: 4
})

const gridClasses = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 md:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
}
</script>